import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=680f7acc&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=680f7acc&lang=scss&scoped=true&"
import style1 from "./_slug.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f7acc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiTagline: require('/app/components/ui/tagline.vue').default,UiCtaLink: require('/app/components/ui/cta-link.vue').default,UiTransition: require('/app/components/ui/transition.vue').default,CaseList: require('/app/components/case/list.vue').default,UiScrollContainer: require('/app/components/ui/scroll-container.vue').default,CaseSingleOverview: require('/app/components/case/single-overview.vue').default,ServicesRelated: require('/app/components/services/related.vue').default,UiContactBlock: require('/app/components/ui/contact-block.vue').default})
